import { IEventRegisterRow } from "../../../services/helper.service.js";

export namespace AKCAtt {
  export const form:IEventRegisterRow[] = [{
    inputs: []
  }];
}
